import { useFormikContext } from "formik";
import { InputField, VerticalForm } from "melco-shared-logic";
import { Alert, Button, FormItem, SaveIcon } from "melco-ui";

import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";




type DisplayAddFolderFormProps = {

    referenceDrawer?: DrawerType,
};

export const DisplayAddFolderForm: React.FC<DisplayAddFolderFormProps> = ({
    referenceDrawer }) => {
    //const { values } = useFormikContext();
    const { submitForm } = useFormikContext();


    //  const { roles } = useRolesContext();


    return (
        <>
            <div>

                <VerticalForm>

                    <FormItem>
                        <Alert
                            message={"Name may only contain lowercase letters, numbers. The name must also be between 3 and 63 characters long"}
                            type="info"
                            withBackground
                            closable={false}
                        />
                    </FormItem>
                    <InputField
                        name="folder_name"
                        label={"New Folder Name"}
                    // onChange={(e)=>setSearchValue(e.target.value)}
                    />
                    <Button
                        icon={<SaveIcon />}
                        type="primary"
                        onClick={() => {
                            submitForm();
                        }}
                    >
                        {"Save"}
                    </Button>
                </VerticalForm>
            </div>


        </>

    );
};
